import { z } from "zod";

enum Action {
  ADMIN = 100,
  DELETE = 200,
  UPDATE = 300,
  READ = 400,
}

enum Resource {
  COUNTERPARTY = "Counterparty",
  DOCUMENT = "Document",
  MEMBER = "Member",
  MEMBER_ROLE = "MemberRole",
  ROLE = "Role",
  ONBOARDING = "OnboardingSession",
}

enum RoleV2 {
  ADMIN = "admin",
  AUDITOR = "auditor",
  COMPLIANCE = "compliance",
  FINOPS = "finops",
  TRADER = "trader",
  ONBOARDING = "onboarding",
  SUPER_ADMIN = "superadmin",
}

const PermissionSchema = z.record(z.string().min(1), z.record(z.string().min(1), z.string().array()));
type PermissionType = z.infer<typeof PermissionSchema>;

export { Action, PermissionSchema, Resource, RoleV2 };
export type { PermissionType };
